import { type FC } from 'react';
import { UiHStack, UiStack, uiStyles, UiText } from '@/lib/ui';
import BaseBlockList from '@/base/BlockList';

interface RegistrationTypeProps {
  attendeeCategory: {
    id: number
    name: string
  }
}

const GroupAttendeeCategory: FC<RegistrationTypeProps> = ({ attendeeCategory }) => {
  return (
    <UiStack spacing={4}>
      <UiHStack justifyContent={'space-between'}>
        <UiText fontWeight={'bold'}>
          Attendee category
        </UiText>
      </UiHStack>
      <BaseBlockList
        bgColor={'#fff'}
        borderRadius={uiStyles.borderRadius}
        enableDivider={true}
        shadow={'none'}
        borderColor={'gray.300'}
        borderWidth={'1px'}
        borderStyle={'solid'}
      >
        <UiStack spacing={1} px={8} py={4}>
          <UiText variant={'body1'}>{attendeeCategory.name}</UiText>
        </UiStack>
      </BaseBlockList>
    </UiStack>
  );
};

export default GroupAttendeeCategory;
